import React from 'react'
import { Checkbox } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import {
  InviteChipEmail,
  InviteChipList,
  InviteChipRow,
  SyncFieldHint,
} from './ClientBillingProfileManagement.styles'

interface HubspotSyncEmailListProps {
  emails: string[]
  /**
   * Whether to offer funding access per address. False hides the checkbox
   * entirely, because this admin cannot grant anyone access.
   */
  canGrant: boolean
  isGranted: (email: string) => boolean
  onGrantedChange: (email: string, granted: boolean) => void
  /** Omitted for a read-only list. */
  onRemove?: (email: string) => void
}

/**
 * The addresses HubSpot returned for one company. These come from the "Send
 * Funding Report" association, so shared inboxes are common: the access
 * checkbox is the only thing standing between one of those and a portal login.
 */
const HubspotSyncEmailList = ({
  emails,
  canGrant,
  isGranted,
  onGrantedChange,
  onRemove,
}: HubspotSyncEmailListProps) => {
  if (emails.length === 0) {
    return <SyncFieldHint>HubSpot listed no contacts.</SyncFieldHint>
  }

  return (
    <InviteChipList>
      {emails.map((email) => (
        <InviteChipRow key={email.toLowerCase()}>
          <InviteChipEmail title={email}>{email}</InviteChipEmail>
          {canGrant ? (
            <Checkbox
              checked={isGranted(email)}
              onChange={(event) => onGrantedChange(email, event.target.checked)}
            >
              Grant access
            </Checkbox>
          ) : null}
          {onRemove ? (
            <CloseOutlined
              role="button"
              tabIndex={0}
              aria-label={`Remove ${email}`}
              onClick={() => onRemove(email)}
              onKeyDown={(event) => {
                if (event.key !== 'Enter' && event.key !== ' ') return
                event.preventDefault()
                onRemove(email)
              }}
            />
          ) : null}
        </InviteChipRow>
      ))}
    </InviteChipList>
  )
}

export { HubspotSyncEmailList }
